module.exports = __webpack_public_path__ + "img/lawterReviewSuccess.ebb7192b.png";